import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import { Formik } from 'formik';
import Confirm from 'components/Confirm';
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import { ModuleAccess } from 'utils/moduleaccess';
import { cloneDeep } from 'lodash';


let tableDataBackup = [];
let rowForEdit = {};
let updatedFields = {};


const WholesalerTable = (props) => {
  const {
   tabKey,
    orgId,
    filters,
    onExport,
    data,
    refetch,
    totalitem,
    onPageChange,
    onSearchColumnFilters = () => '',
    fetchWholesalerAll,
    accm,
    accuntErr,
    setAccountErr,
    collapseSider,
    toggleSider,
    resetFilterFlag,
    SetResetFilterFlag
  } = props;

  // tableDataBackup = data;
  console.log(totalitem,"totalRecords In WholeSaler TAble")
  const [tableData, setTableData] = useState(tableDataBackup);
  const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
  const [drawerPODetails, setDrawerPODetails] = useState('');
  const [isOpenView, setOpenView] = useState(false);
  const [isOpenHistory, setOpenHistory] = useState(false);
  const [reset, setReset] = useState(false);
  const [selectedRow, setselectedRow] = useState({});
  const [selectedRowHistory, setSelectedRowHistory] = useState({});
  const [commentDrawer, setCommentDrawer] = useState(false);
  const [commentRowData, setCommentRowData] = useState({});
  const [modal, setModal] = useState(false);
  const [isConfirm, setConfirm] = useState(false);
  const [hasTouched, setTouched] = useState('');
  const [loading, setLoading] = useState(false)
  const [err1, setErr1] = useState(false);
  const [errstatus, setErrstatus] = useState(false);
  const [errAccountNum, setErrAccountNum] = useState(false)
   const [columnFilters, setColumnFilters] = useState([]);


  const API = useAxios()
  const toggle = () => setModal(!modal);

  // useEffect(() => {
  //   setTableData(data);
  //   tableDataBackup = data;
  // }, [data]);
  let AccountEdit= [
    {
      "id":"1001",
      "label":"340B"
    },
    {
      "id":"1002",
      "label":"GPO"
    },
    {
      "id":"1003",
      "label":"WAC"
    }
  ]
  let StatusEdit= [
    {
      "id":"N",
      "label":"Active"
    },
    {
      "id":"Y",
      "label":"Inactive"
    }
  ]

  const hasPermission = (code) => {
    return ModuleAccess("DRC", code);
  };

  const togglePODetailsDrawer = () => {
    setisPODetailsOpen(!isPODetailsOpen);
    setDrawerPODetails('');
  };

  const toggleViewPODetailsDrawer = () => {
    setOpenView(!isOpenView);
  
  };
  const toggleAttachPODetailsDrawer = () => {
    setCommentDrawer(!commentDrawer);

  };
  const handleConfig = async (rowData) => {
    await manvalConfig();

  }
  const handelAddCoveredEntity = async (rowData) => {
    await manvalPharmacy();

  }
  const handelWacPrice = async (rowData) => {
    await toggleWacDetails(rowData);
  }
  const handel340BPrie = async (rowData) => {
    await toggle340Betails(rowData);
  }
  const handelGpoPrice = async (rowData) => {
    await toggleWGpoDetails(rowData);
  }


  const renderConfigButton = () => {

    return <Button
      className='text-primary p-0 text-decoration-none'
      color='link'
      onClick={() => handleConfig()}
      title='Client Configuration'

    >
      <HoverImage
        src={ConfigIcon}
        hoverSrc={ConfigIconHover}
        alt='' />
    </Button>
  }
  const renderEditButton = (rowData) => {
    if (hasPermission("ED"))

    return (
      <Button
        className='text-primary p-0 text-decoration-none'
        color='link'
        onClick={() => editRow(rowData)}
        title='Edit'
        hidden={rowData.isediActive == "Y"}
      >
        <HoverImage
          // key='EyeIcon'
          src={EditIcon}
          hoverSrc={EditHoverIcon}
          alt=''
        />
      </Button>
    );
  };
  const formatter = (row, col, formatterType) => {
    // debugger;
    if(formatterType=="DrugstatusList"){

        return (
            <CellEditRender
            err1={err1}
                row={row}
                col={col}
                formatterType={formatterType}
                hasTouched={hasTouched}
                onChange={updateRowValue}
                // alwaysEditableCheckbox={alwaysEditableCheckbox}
                listArray={AccountEdit}
                // drugexclusion={true}
            />
        );
    }
    else if(formatterType=="statusList2"){

      return (
          <CellEditRender
          errstatus={errstatus}
              row={row}
              col={col}
              formatterType={formatterType}
              hasTouched={hasTouched}
              onChange={updateRowValue}
              // alwaysEditableCheckbox={alwaysEditableCheckbox}
              listArray={StatusEdit}
              // drugexclusion={true}
          />
      );
  }
    else{
            return (
                <CellEditRender
                errAccountNum={errAccountNum}
                    row={row}
                    col={col}
                    formatterType={formatterType}
                    onChange={updateRowValue}
                    // alwaysEditableCheckbox={alwaysEditableCheckbox}
                />
            );
        }
  };
  const updateRowValue = (value, col) => {
    debugger;
      const tempRow = { ...rowForEdit };
      tempRow[col] = value;
       rowForEdit = tempRow;
       console.log('Updated row:', rowForEdit);
    };
  const editRow = (rowData, isEdit = true) => {
    // debugger;
   console.log(rowData,"rOWdATA IN EDIT rOW   ");
  
      let tempData = [...data];
      console.log(tempData,"tempData in Edit Row")
      tempData = tempData.map((row) => {
        // debugger;
          row.isEdit = false;
          if (row.wholesalerAccountID === rowData?.wholesalerAccountID && isEdit) {
              row.isEdit = isEdit;
              //  row.accountTypeNumber=parseInt(row.accountTypeNumber)
              // row.accountType=rowData.accountType;
              // row.endDate=dateFormate(row.endDate)
              rowForEdit = row;
               console.log(rowForEdit,"rowForEdit in edit Row")
              console.log(row,"row in edit Row")
          }
          return row;
          
      });
      setTouched('');
      //    setSelectedStatus('');
      setErrstatus(false);
      setErr1(false);
      setErrAccountNum(false);
      setAccountErr(false);
      updatedFields = {};
      //  tableDataBackup = tempData;
      setTableData(tempData);
  };
  const toggleView = (rowData) => {
    setOpenView(!isOpenView);
    setselectedRow(rowData);
  };

  const toggleCommentDrawer = (rowData) => {
    setCommentDrawer((pre) => !pre);
    setCommentRowData(rowData);
  };
  // const handleSaveConfirmation = () => {
  //   setConfirm(!isConfirm);
  // };

  const cellRenderEdit = (rowData) => {
   // if (hasPermission("ED"))

    if(rowData.isEdit)
    {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={savePanelUpdateRow}
          >
            <HoverImage
              key="SaveIcon"
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=""
            />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
             onClick={() => editRow(rowData, false)}
          >
            <HoverImage
              key="CancelIcon"
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=""
            />
          </Button>
        </div>
      );
    }
    return (
      <div className='d-flex align-items-center'>
      {renderEditButton(rowData)}
      </div>
    );
  };
  const renderCheckBox = (rowData, col) => {
        // Determine the color based on the status (inactive or active)
        if (rowData.accountInactiveFlag === "N") {
          return (
              <span>Active</span>
          );
        }
        else if (rowData.accountInactiveFlag === "Y") {
          return (
            <span>Inactive</span>
          );
        }
        // else{
        //   return (
            
        // );
        // }
    };




  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      action: true,
    },
    {
      dataField: "accountInactiveFlag",
      text: "Status",
      sort: false,
      width: 110,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      // cellRenderer: (row, col) => formatter(row, col, "statusList2")
      cellRenderer: (rowData, col) =>
        rowData.isEdit == true
          ? formatter(rowData, col, "statusList2")
          : renderCheckBox(rowData, col),
    },
    {
      dataField: "wholesalerName",
      text: "Wholesaler Name",
      sort: false,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.wholesalerName),
    },
    {
      dataField: "hospitalName",
      text: "Hospital Name",
      sort: true,
      width: 240,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.hospitalName),
    },

    {
      dataField: "accountTypeName",
      text: "Account Type",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (row, col) => formatter(row, col, "DrugstatusList"),
    },
    {
      dataField: "accountCode",
      text: "Acct #",
      sort: true,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => formatter(rowData, col, "text"),
    },
    {
      dataField: "isediActive",
      text: "EDI Active",
      sort: true,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.isediActive),
    },
    {
      dataField: "dateAdded",
      text: "Date Added",
      sort: true,
      width: 140,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: "createdByID",
      text: "Added By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.createdByID),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 150,
      show: true,
      inputType: "date",
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
  ];


  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    debugger
    for(var x in colFilter){
      if(colFilter[x].filterName == 'accountInactiveFlag'){
        if(colFilter[x].filterValue !=="N" && colFilter[x].filterValue !=="Y"){
         colFilter[x].filterValue = (colFilter[x].filterValue) == "Active" ? "N" : "Y"
        }    
      }
    }
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      setColumnFilters(colFilter)
    }
  };

  const handleFilterCancel = () => {
      setColumnFilters([])
    refetch(accm);
  };

  const handleExport = async () => {
         debugger;
         setLoading(true);
         const filterObj = cloneDeep(filters);
         // filterObj.AccumulatorIDs = filterObj.accumulationIds;
         // delete filterObj.accumulationIds;
         if (columnFilters && columnFilters.length > 0) {
           filterObj.filters = [...filterObj.filters, ...columnFilters];
         }
     
         const { access_token } =
           JSON.parse(localStorage.getItem('pharmaforce')) || {};
     
           var additionalCriteria = {};
           additionalCriteria.IsSelectedColumn = false;
           additionalCriteria.OrgId = orgId.organizationID;
            // additionalCriteria.ContractId = 0;
         // additionalCriteria.POId = 0;
         // additionalCriteria.OpaId = 0;
         // additionalCriteria.CEId = 0;
         // additionalCriteria.ManufactureId = 0;
     
         var payload = {};
         payload.tenantID = orgId.tenantID
         payload.gridCode = "drugwholesalers";
         payload.fileTypeCode = "csv";
         payload.criteria = JSON.stringify(filterObj);
         payload.additionalCriteria = JSON.stringify(additionalCriteria);
         const { data } = await API.post(`export/queue`, payload, {
           hasExport: true,
         });
         setLoading(false);
       //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
       //  onExport(action, initialFilters);
       };

  
  const checkvalidation = (selectedvaluesonly) => {
    debugger;
    if (selectedvaluesonly.accountInactiveFlag == null || selectedvaluesonly.accountInactiveFlag == "" ) {
        setErrstatus(true);
        return true;
    }
    else  if ((selectedvaluesonly.accountTypeName == undefined || selectedvaluesonly.accountTypeName == null || selectedvaluesonly.accountTypeName == "")) {
      setErr1(true);
      return true;
    }
    else if ((selectedvaluesonly.accountCode == undefined || selectedvaluesonly.accountCode == null || selectedvaluesonly.accountCode == "")) {
      setErrAccountNum(true);
      return true;
  }
    else {
        return false;
    }
  
  }
  const savePanelUpdateRow = async () => {
        debugger;
        // handleSaveConfirmation();
        if (checkvalidation(rowForEdit))
            return true;
  
        setLoading(true);
  
        const payload = { ...rowForEdit };
        payload.Status = payload.accountInactiveFlag;
        payload.AccuntNumber = payload.accountCode;
        payload.AccountTypeID = payload.accountTypeName == "340B" ? 1001: payload.accountTypeName == "GPO" ? 1002 : 1003;
        payload.PrevoiusaccountID = payload.accountTypeId;
        payload.WholesalerAccountID = payload.wholesalerAccountID;
        delete payload.isEdit;
        ;
        try {
            const result = await API.post(
                `SBTenant/${orgId.tenantID}/DrugCatalog/UpdateDrugWholesaler`,
                payload,
                {
                    hasDefaultURL: true,
                },
            );
  
            if (result) {
  
                if (result.data.error) {
                    //toast.error(result.data.message);
                    setAccountErr(true);
                }
                else {
                    toast.success(result.data.message);
                    setAccountErr(false);
                    refetch(accm);
                    
                }
                setLoading(false);
                // refetch(accumualator,selectedHospital);
               
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

  return (
    <div>
       <h5 className="f-16 text-primary font-weight-700">
         Wholesalers Count  ({totalitem})
            </h5>
            <hr/>
      <div
        // className="table-card scroll-table position-relative border-0 rounded pt-0"
        // fixed-height={data.length > 0 ? "fixed-height" : "default"}
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          data.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
      >
        <ReactStrapTable
          id="wholesaler-table"
          height={550}
          fixedColumn
          width={1200}
          reset={reset}
          hasPagination={data.length > 0 ? true : false}
          data={data}
          columns={mainCol}
          onExport={handleExport}
          filters={filters}
          totalRecords={totalitem}
          pageSize={filters.pageSize}
          currentPage={filters.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          accuntErr={accuntErr}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
         showtoggle={true}
          resetFilterFlag={resetFilterFlag}
          SetResetFilterFlag={SetResetFilterFlag}
          keytab={tabKey}
        />
      </div>
      {/* <Confirm
            isOpen={isConfirm}
            loading={loading}
            message='This change will be effective going forward, to reprocess charges in the past please submit a ticket to support@thepharmaforce.com'
            onToggle={handleSaveConfirmation}
            onCancel={handleSaveConfirmation}
            onContinue={savePanelUpdateRow}
        /> */}

      <Modal
        isOpen={modal}
        fade={false}
        toggle={toggle}
        className={props.className}
      >
        <ModalHeader toggle={toggle}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            McKesson Upload Order
          </h5>
        </ModalHeader>
        <ModalBody>
          <div>
            <Formik
              children={(props) => {
                return (
                  <div hidden={""}>
                    <Row sm={5}>
                      <Col md={12} lg={12} sm={12} xs={12}>
                        {" "}
                        <FormGroup>
                          <Label for="file">Choose File</Label>
                          <Input
                            id="file"
                            name="file"
                            type="file"
                            placeholder="Enter Contact Person Name"
                            autoComplete="off"
                            value={""}
                            component={""}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>
            Load Order
          </Button>{" "}
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default WholesalerTable
